import PORTFOLIO_DATA from "../../resources/portfolio-data";
import Footer from "../footer/footer";
import { Link } from "react-router-dom";
import "./portfolio.styles.scss";
import { linksHandler } from "../../utils/linkhandler";
import React, { useContext } from "react";
import { ScrollContext } from "../../context/scroll-to";
const Portfolio = () => {
  
  const {portfolioSection} = useContext(ScrollContext);

  return (
    <React.Fragment>
    <section className="portfolio section" ref={portfolioSection}>
      <div className="port-heading">
        <h2 className="portfolio-head">Portfolio</h2>
      </div>

      <div className="all-cards">
        {PORTFOLIO_DATA.map((card) => {
          return (
            <div key={card.id} className={`cards card-${card.id}`}>
              <Link
                className="portfolio-link"
                onClick={() => linksHandler(card.webUrl)}
              >
                <div className="card-heading">
                  <h3>{card.name}</h3>
                </div>
                <div className="card-image">
                  <img src={card.imgUrl} alt={card.name.toLowerCase()} />
                </div>
              </Link>
            </div>
          );
        })}
      </div>
      <Footer />
    </section>
    </React.Fragment>
  );
};

export default Portfolio;
